




















































import Vue from 'vue';
import SectionRow from './SectionRow.vue';
import SectionRowMixin from '@/components/section-row/mixins/SectionRowMixin.vue';
import SectionRowItemMixin from '@/components/section-row/mixins/SectionRowItemMixin.vue';
import { CvSectionGallery, CvSectionGalleryItem } from '@/../gen';

export default Vue.extend({
  components: {
    SectionRow,
  },
  mixins: [SectionRowMixin, SectionRowItemMixin],
  computed: {
    section(): CvSectionGallery {
      return this.cvCvSection.section;
    },
    sectionItems(): CvSectionGalleryItem[] {
      return this.cvCvSection.sectionItems;
    },
    editLink() {
      return {
        name: 'cv_section_galleries_edit_path',
        params: { cv_id: this.section.cv_id, id: this.section.id },
      };
    },
    addLink() {
      return {
        name: 'cv_section_gallery_items_new_path',
        params: {
          cv_id: this.section.cv_id,
          cv_section_gallery_id: this.section.id,
        },
      };
    },
  },
  methods: {
    editItemLink(item: CvSectionGalleryItem) {
      return {
        name: 'cv_section_gallery_items_edit_path',
        params: {
          cv_id: this.section.cv_id,
          cv_section_gallery_id: this.section.id,
          id: item.id,
        },
      };
    },
  },
});
